class cartFrequency extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.isFrequencyLoaded = false;
    this.bindEvents();
  }

  bindEvents() {
    const prevFrequency = localStorage.getItem("cart-frequency");
    if(prevFrequency != null) {
      document.querySelector(`.cart-frequency-widget input[value="${prevFrequency}"]`).click();
    }
    this.isFrequencyLoaded = true;

    document.querySelectorAll('.cart-frequency-options input').forEach((radio) => {
      radio.addEventListener('change', () => {
        localStorage.setItem("cart-frequency", radio.value);
        this.updateCart(radio.value);
        this.classList.add('loading');
      })
    })
  }

  async updateCart(frequency) {
    if(!this.isFrequencyLoaded) return;
    let cartData = [];
    document.querySelectorAll('.cart-item[data-cart-item]').forEach((item) => {
      const itemData = JSON.parse(item.dataset.cartItem);
      let newData = {
        id: itemData.id,
        quantity: itemData.quantity,
        properties: itemData.properties
      }
      if(itemData.plans.length > 0 && frequency != 'onetime') {
        if (frequency == 'week') {
          newData['selling_plan'] = itemData.plans[0].id;
        }
        else if (frequency == 'fortnight') {
          newData['selling_plan'] = itemData.plans[1].id;
        }
      }
      cartData.push(newData);
    })
    cartData.reverse();
    if(cartData.length > 0){
      localStorage.setItem("cart-refresh", true);
      await fetch('/cart/clear.js');
      // Save cart data into storage to add back incase below add.js doesn't work.
      localStorage.setItem("freq-add-data", JSON.stringify(cartData));
      await fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({
          items: cartData
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      localStorage.setItem("freq-add-data", '');
      window.location.href = window.location.pathname + '?cart=open';
    }
  }
}

customElements.define('cart-frequency', cartFrequency);